window.timberSlider = window.timberSlider || {};
timberSlider.cacheSelectors = function () {
timberSlider.cache = {$slider: $('.flexslider')}};
timberSlider.init = function () {timberSlider.cacheSelectors(); timberSlider.sliders();};
timberSlider.sliders = function () {var $slider = timberSlider.cache.$slider, sliderArgs = {
animation: 'fade',
animationSpeed: 500,pauseOnHover: true, keyboard: false, slideshow: true, slideshowSpeed: 4000, controlNav: true, smoothHeight: true};
if ($slider.length) { if ($slider.find('li').length === 1) {sliderArgs.slideshow = false; sliderArgs.slideshowSpeed = 0; sliderArgs.controlNav = false; sliderArgs.directionNav = false; sliderArgs.touch = false;} $slider.flexslider(sliderArgs);}};
$(window).on('load', function() { timberSlider.init();});
